<div *ngIf="addressForm">
  <form [formGroup]="addressForm" class="address-form">

    <!-- SELECT ADDRESS (IF LOGGED IN) -->
    <div class="row">
      <div class="col-12" *ngIf="customer.id > 0">
        <pv-customer-address
          #customerAddress
          [default]="default"
          [selectable]="selectable"
          [editable]="editable"
          [collapsed]="collapsed"
          (onSelectAddress)="onSelectAddress($event)"
          (onEditAddress)="onEditAddress($event)"
          (onNewAddress)="onNewAddress($event)"
        ></pv-customer-address>
      </div>
    </div>

    <!-- SAME AS DEFAULT -->
    <button *ngIf="(showForm || !(customer.id > 0)) && defaultText && defaultAddress" class="pv-button same-as-billing" (click)="sameAsBilling()">{{ defaultText }}</button>

    <!-- ADDRESS INFO FORM -->
    <div class="row" *ngIf="showForm || !(customer.id > 0)">
      <div class="col-6 required">Required<span class="warn-color">*</span></div>
    </div>

    <div class="row" *ngIf="showForm || !(customer.id > 0)">
      <div class="col-md-7">
        <!-- FIRSTNAME -->
        <div class="form-group">
          <label for="ship_firstname"><span class="warn-color">*</span> First Name</label>
          <input type="text" class="form-control" formControlName="ship_firstname" required>
        </div>
      </div>

      <!-- LASTNAME -->
      <div class="col-md-7">
        <div class="form-group">
          <label for="ship_lastname"><span class="warn-color">*</span> Last Name</label>
          <input type="text" class="form-control" id="ship_lastname" formControlName="ship_lastname">
        </div>
      </div>

      <!-- COMPANY -->
      <div class="col-md-7">
        <div class="form-group">
          <label for="company"><span class="warn-color" *ngIf="customer.is_wholesale">*</span> Company</label>
          <input type="text" class="form-control" id="company" formControlName="company">
        </div>
      </div>

      <!-- ADDRESS1 -->
      <div class="col-md-7">
          <div class="form-group">
            <label for="ship_addr1"><span class="warn-color">*</span> Address</label>
            <input type="text" class="form-control" id="ship_addr1" formControlName="ship_addr1">
          </div>
      </div>

      <!-- ADDRESS2 -->
      <div class="col-md-7">
          <div class="form-group">
            <label for="ship_addr2">Address Line 2</label>
            <input type="text" class="form-control" id="ship_addr2" formControlName="ship_addr2">
          </div>
      </div>

      <!-- CITY -->
      <div class="col-md-7">
        <div class="form-group">
          <label for="ship_city"><span class="warn-color">*</span> City</label>
          <input type="text" class="form-control" id="ship_city" formControlName="ship_city">
        </div>
      </div>

      <!-- STATE -->
      <div class="col-md-7">
        <div class="form-group">
          <label for="ship_state">State/Province (US/Canada Only)</label>
          <select class="form-control" formControlName="ship_state" autocomplete="shipping address-level1 state" name="state" id="state">
            <option selected [ngValue]="false">Select A State...</option>
            <optgroup label="United States"></optgroup>
            <option *ngFor="let state of usStates" [ngValue]="state.abbr">{{ state.label }}</option>
            <optgroup label="Canada"></optgroup>
            <option *ngFor="let state of canadaStates" [ngValue]="state.abbr">{{ state.label }}</option>
          </select>
        </div>
      </div>

      <!-- ZIP -->
      <div class="col-md-7">
        <div class="form-group">
          <label for="ship_zip"><span class="warn-color">*</span> Zip / Postal Code</label>
          <input type="text" class="form-control" id="ship_zip" formControlName="ship_zip">
        </div>
      </div>

      <!-- COUNTRY -->
      <div class="col-md-7">
        <div class="form-group">
          <label for="ship_country_iso"><span class="warn-color">*</span> Country</label>
          <select class="form-control" formControlName="ship_country_iso" autocomplete="country">
            <option *ngFor="let country of countries" [ngValue]="country.iso">{{ country.title }}</option>
          </select>
        </div>
      </div>

      <!-- BRAZIL TAX ID -->
      <div class="col-md-7" *ngIf="addressForm.get('ship_country_iso').value == 'BR' && account && account.id == 2">
        <div class="form-group">
          <label for="tax_id"><span class="warn-color">*</span> Tax Id</label>
          <input type="text" class="form-control" id="tax_id" formControlName="tax_id">
        </div>
      </div>

      <!-- PHONE -->
      <div class="col-md-7">
          <div class="form-group">
            <label for="ship_phone">Phone Number (Required for International Orders)</label>
            <input type="text" class="form-control" id="ship_phone" formControlName="ship_phone">
          </div>
        </div>
    </div>

    <!-- STATE ERROR MESSAGE -->
    <div *ngIf="showForm && addressForm.errors?.state && (addressForm.touched || addressForm.dirty)" class="cross-validation-error-message alert alert-danger">
      State is required
    </div>

    <!-- PHONE NUMBER ERROR MESSAGE -->
    <div *ngIf="showForm && addressForm.errors?.international && (addressForm.touched || addressForm.dirty)" class="cross-validation-error-message alert alert-danger">
      Phone Number is required
    </div>

    <div *ngIf="editing && !hideUpdate" class="col-md-4 pv-button" [ngClass]="{ disabled: addressForm.invalid }" (click)="addressForm.valid && editAddress()">
      Update Address
    </div>

    <div *ngIf="adding && customer && customer.id > 0" class="col-md-4 pv-button" [ngClass]="{ disabled: addressForm.invalid }" (click)="addressForm.valid && addAddress()">
      Add Address
    </div>
  </form>
</div>